import React from 'react';

interface Props {
  width?: string;
  fill?: string;
}

const PlayIconCourse: React.FC<Props> = ({ width = '25', fill = 'white' }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.9699 22C17.4928 22 21.9699 17.5228 21.9699 12C21.9699 6.47715 17.4928 2 11.9699 2C6.44708 2 1.96992 6.47715 1.96992 12C1.96992 17.5228 6.44708 22 11.9699 22Z'
        fill='black'
        fillOpacity='0.4'
        stroke='white'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M16.4258 12.25L10.0664 16.4896C10.0212 16.5196 9.96874 16.5369 9.91454 16.5395C9.86034 16.5421 9.80644 16.5299 9.7586 16.5043C9.71076 16.4787 9.67077 16.4406 9.64287 16.394C9.61498 16.3475 9.60023 16.2942 9.6002 16.24V7.76078C9.60023 7.70652 9.61498 7.65328 9.64287 7.60673C9.67077 7.56018 9.71076 7.52207 9.7586 7.49646C9.80644 7.47084 9.86034 7.45869 9.91454 7.46128C9.96874 7.46387 10.0212 7.48112 10.0664 7.51118L16.4258 11.7508C16.4669 11.7782 16.5006 11.8153 16.5239 11.8588C16.5472 11.9024 16.5594 11.951 16.5594 12.0004C16.5594 12.0498 16.5472 12.0984 16.5239 12.1419C16.5006 12.1855 16.4669 12.2226 16.4258 12.25Z'
        fill={fill}
      />
    </svg>
  );
};

export default PlayIconCourse;
